export default "__VITE_ASSET__3aba7430__"